<template>
  <div id="app">
    <!--<Download />-->
    <router-view></router-view>
  </div>
</template>

<script>
import Download from './components/Download.vue'

export default {
  name: 'app',
  components: {
    Download
  }
}
</script>

<style>
#app {
}

/*隐藏站长统计*/
#cnzz_stat_icon_1275469955 {
    display: none;
}
</style>
